"use client";

import { useState } from "react";

const faqs = [
  {
    q: "Where is my data stored?",
    a: "All data is stored on Google Cloud infrastructure within secure, regionally-isolated environments. Your files, analyses, and conversations are tied exclusively to your account and never co-mingled with other users' data.",
  },
  {
    q: "Do you use my data to train AI models?",
    a: "No. Your data is never used to train, fine-tune, or improve any AI model — ours or third-party providers. It is processed solely to generate your requested outputs and then discarded.",
  },
  {
    q: "How long do you keep uploaded files?",
    a: "Uploaded files are retained for a maximum of 24 hours after processing. Analysis results and conversation history persist while your account is active and are deleted immediately upon a hard-delete request.",
  },
  {
    q: "Is sensei GDPR compliant?",
    a: "Yes. We support the full suite of GDPR data subject rights: access, deletion, portability, and transparent processing. You can export or delete all your data at any time directly from your account settings.",
  },
  {
    q: "What encryption does sensei use?",
    a: "All data in transit is protected with TLS 1.3. Data at rest — including files, records, and backups — is encrypted using enterprise-grade encryption across our cloud infrastructure.",
  },
  {
    q: "Can other users access my data?",
    a: "No. Every file, analysis, and conversation is scoped to your unique user ID. Database security rules enforce strict ownership at the infrastructure level, making cross-user access architecturally impossible.",
  },
  {
    q: "What happens if I delete my account?",
    a: "All your data — files, analyses, conversations, and personal information — is permanently deleted immediately upon account deletion. There is no recovery window after a hard delete.",
  },
];

export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="sec-faq-list">
      {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={faq.q} className={`sec-faq-item${isOpen ? " sec-faq-item--open" : ""}`}>
            <button
              className="sec-faq-question"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              <span>{faq.q}</span>
              <span className="sec-faq-icon" aria-hidden="true">{isOpen ? "×" : "+"}</span>
            </button>
            {isOpen && <p className="sec-faq-answer">{faq.a}</p>}
          </div>
        );
      })}
    </div>
  );
}
